export default __webpack_public_path__ + "static/media/pdf_Icon.5f3b9efe.svg";